module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "Body_Heading2B"
  }, [_vm._v("Also by David Kundtz")]), _vm._v(" "), _c('p', {
    staticClass: "Body_List--Centered-"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("The Art of Stopping: How to Be Still When You Have to ")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Keep Going")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body_List--Centered-"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Quiet Mind: One Minute M")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("indfulness")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body_List--Centered-"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Awakened Mind: One Minute Wak")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("e Up Calls")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body_List--Centered-"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Being Present: A Book of Daily R")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("eflections")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body_List--Centered- _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Coming To: A Biom")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("ythography")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08ebada0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NothingsWrong.vue
// module id = 60
// module chunks = 0